import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAssetCloud = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      fill="url(#Asset_Cloud_svg__a)"
      fillOpacity={0.5}
      fillRule="evenodd"
      d="M5.226 9.83C4.933 7.026 7.175 4.559 10 4.559a4.78 4.78 0 0 1 4.775 5.273c1.607-.049 2.923 1.16 2.923 2.805a2.817 2.817 0 0 1-2.825 2.806H5.128a2.817 2.817 0 0 1-2.826-2.806c0-1.644 1.315-2.854 2.923-2.805Z"
      clipRule="evenodd"
    />
    <defs>
      <linearGradient
        id="Asset_Cloud_svg__a"
        x1={14.811}
        x2={-4.427}
        y1={12.551}
        y2={11.984}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="var(--dataviz-color-sequential-blue-scale06)" />
        <stop
          offset={1}
          stopColor="var(--dataviz-color-sequential-blue-scale02)"
        />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgAssetCloud;
